import { useModel as _useModel, defineComponent as _defineComponent } from 'vue'
import { unref as _unref, isRef as _isRef, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import Select from "@/components/FormInput/Select.vue";
import DateUtility from "@/ts/Utility/DateUtility";

type Option = {
  value: string,
  text: string,
  disabled?: boolean
}

export default /*@__PURE__*/_defineComponent({
  __name: 'TimeZoneInput',
  props: {
    "modelValue": {},
    "modelModifiers": {},
  },
  emits: ["update:modelValue"],
  setup(__props) {

const [model] = _useModel(__props, "modelValue")
const currentTime = new Date();

const options: Option[] = Object.entries(DateUtility.getTimeZoneMap()).map(([offset, value]) => {
  const text = offset.replace('00','0')
  const time = currentTime.toLocaleTimeString('ru-RU', {hour: '2-digit', minute: '2-digit', timeZone: value})
  return {
    value,
    text:  `${time} (UTC ${text})`
  }
});
if (!(DateUtility.hasTimeZone(model.value as string))) {
  model.value = "Europe/Moscow";
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(Select, {
    options: _unref(options),
    modelValue: _unref(model),
    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (_isRef(model) ? (model).value = $event : null)),
    class: "select"
  }, null, 8, ["options", "modelValue"]))
}
}

})